<template>
  <footer class="page-footer" role="contentinfo">
    <div class="d-flex align-items-center flex-1 text-muted">
      <span class="hidden-md-down fw-700"
        >2026 フュージョンアウトドア by&nbsp;<a
          href="https://fusion-outdoor.co.jp/"
          class="text-primary fw-500"
          title="https://fusion-outdoor.co.jp/"
          target="_blank"
          >https://fusion-outdoor.co.jp/</a
        ></span
      >
      <span
        data-ver="ver 20261006042948"
        class="hidden-md-down fw-700"
        style="margin-left: 20px"
        >v 3.0.0</span
      >
    </div>
    <div>
      <template v-if="isProd()">
        <span class="badge badge-success">Production</span>
      </template>
      <template v-else>
        <span class="badge badge-warning">Development</span>
      </template>
    </div>
  </footer>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { isProdEnv } from "furukawa-common/src/common/constant/Constants";

@Options({})
export default class Tm_footer extends Vue {
  isProd(): boolean {
    return isProdEnv();
  }
}
</script>
